import PropTypes from 'prop-types'
import { UiBreadcrumb } from 'components/common'
import { Box, Flex, Heading } from '@chakra-ui/react'
import { CommissionProjects } from './CommissionProjects'
import { CommissionChangeOrders } from './CommissionChangeOrders'
import { useAppContext } from 'hooks/useAppContext'
import { ROLES } from 'lib'

const BreadcrumbNav = [
  {
    label: 'Commission Portal',
    isCurrentPage: true
  }
]

export const Commission = ({ isMyCommission = false }) => {
  const { currentUser } = useAppContext()

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Commission Portal</Heading>
        </Flex>
        <CommissionProjects isMyCommission={isMyCommission} />
        {!isMyCommission && currentUser?.role !== ROLES.SalesUser && (
          <CommissionChangeOrders mt={4} />
        )}
      </Box>
    </>
  )
}

Commission.propTypes = {
  isMyCommission: PropTypes.bool
}
